<template>
  <div class="bill-generation-page">
    <!-- 顶部工具栏（同缴费查询风格） -->
    <a-card class="toolbar-card" :bordered="false">
      <div class="toolbar-row">
        <div class="toolbar-left">
          <div class="page-title">账单生成</div>
          <div class="page-sub muted">选择一种生成方式：单户单月 / 单户多月批量。</div>
        </div>

        <div class="toolbar-right">
          <a-button icon="unordered-list" @click="goToFeeQuery">返回缴费查询</a-button>
        </div>
      </div>
    </a-card>

    <!-- 切换卡片 -->
    <a-row :gutter="16" class="switch-row">
      <a-col :xs="12" :md="6">
        <a-card class="switch-card" :class="{ active: activeTab === 'single' }" :bordered="false" hoverable @click="activeTab='single'">
          <div class="switch-title">单个账单</div>
          <div class="switch-sub">单户 · 单月</div>
        </a-card>
      </a-col>

      <a-col :xs="12" :md="6">
        <a-card class="switch-card" :class="{ active: activeTab === 'batch' }" :bordered="false" hoverable @click="activeTab='batch'">
          <div class="switch-title">批量账单</div>
          <div class="switch-sub">单户 · 多月</div>
        </a-card>
      </a-col>

      <!-- ✅ 新增：管理收款账号 -->
      <a-col :xs="24" :md="6">
        <a-card class="switch-card" :class="{ active: activeTab === 'pay_accounts' }" :bordered="false" hoverable @click="openPayAccountsTab">
          <div class="switch-title">管理收款账号信息</div>
          <div class="switch-sub">行内编辑 · 新增/删除</div>
        </a-card>
      </a-col>
    </a-row>

    <!-- 内容卡：只显示当前 Tab -->
    <a-card class="content-card" :bordered="false">
      <!-- 单个生成 -->
      <div v-show="activeTab === 'single'">
        <div class="section-head">
          <div class="section-title">单个账单生成</div>
          <a-tag color="blue">单户 · 单月</a-tag>
        </div>

        <a-form layout="vertical" class="form-wrap">
          <a-row :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item label="楼号 *">
                <a-input v-model="single.building" allowClear placeholder="请输入楼号" @blur="tryFetchFloorArea"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item label="房号 *">
                <a-input v-model="single.room" allowClear placeholder="请输入房号" @blur="tryFetchFloorArea"/>
              </a-form-item>
            </a-col>

           <!-- 账单起始日期（只选起始日） -->
            <a-col :xs="24" :md="12">
              <a-form-item label="账单起始日期 *">
                <a-date-picker
                  v-model="single.startDate"
                  style="width:100%"
                  format="YYYY-MM-DD"
                  placeholder="请选择起始日期"
                  @change="onSingleStartDateChange"
                />
              </a-form-item>
            </a-col>

            <!-- 自动计算的账单结束日期 -->
            <a-col :xs="24" :md="12">
              <a-form-item label="账单结束日期（自动）">
                <a-input :value="singleEndDateText" disabled placeholder="选择起始日期后自动计算" />
              </a-form-item>
            </a-col>


            <!-- 费用类型：只保留 物业费/房租 -->
            <a-col :xs="24" :md="12">
              <a-form-item label="费用类型">
                <a-select v-model="single.feeType">
                  <a-select-option value="物业费">物业费</a-select-option>
                  <a-select-option value="房租">房租</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <!-- 每平米费用 -->
            <a-col :xs="24" :md="12">
              <a-form-item label="每平米费用（元）">
                <a-input-number
                  v-model="single.amountPerSqm"
                  :min="0"
                  :step="0.01"
                  :precision="2"
                  style="width: 100%"
                  placeholder="请输入每平米费用"
                />
              </a-form-item>
            </a-col>

            <!-- 面积展示（来自 accounts 接口） -->
            <a-col :xs="24" :md="12">
              <a-form-item label="房屋面积（㎡）">
                <a-input
                  :value="floorAreaText"
                  disabled
                  placeholder="输入楼号/房号后自动获取"
                />
              </a-form-item>
            </a-col>

            <!-- 本期费用金额（自动计算） -->
            <a-col :xs="24" :md="12">
              <a-form-item label="本期费用金额（元）">
                <a-input
                  :value="calculatedAmountText"
                  disabled
                  placeholder="面积 × 每平米费用"
                />
              </a-form-item>
            </a-col>


            <!-- <a-col :xs="24" :md="12">
              <a-form-item label="费用类型">
                <a-select v-model="single.feeType">
                  <a-select-option v-for="t in feeTypes" :key="t" :value="t">{{ t }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
          </a-row>

          <div class="form-actions">
            <a-button type="primary" :loading="loading.single" @click="handleSingleGenerate">
              生成单个账单
            </a-button>
            <a-button :disabled="loading.single" @click="resetSingle">清空</a-button>
          </div>

          <!-- 单个结果 -->
          <div v-if="singleResultVisible" class="result-box">
            <a-alert
              v-if="errorMessage"
              :message="errorMessage"
              type="error"
              show-icon
              style="margin-bottom: 12px"
            />
            <a-card v-if="billGenerationResult" class="result-card" :bordered="false">
              <div class="result-head">
                <div class="result-title">生成成功</div>
                <a-tag color="green">{{ billGenerationResult.feePeriod }}</a-tag>
              </div>
              <a-descriptions :column="2" size="small" bordered>
                <a-descriptions-item label="业主姓名">{{ billGenerationResult.ownerName }}</a-descriptions-item>
                <a-descriptions-item label="房屋">
                  {{ billGenerationResult.building }}号楼{{ billGenerationResult.room }}室
                </a-descriptions-item>
                <a-descriptions-item label="费用类型">{{ billGenerationResult.feeType }}</a-descriptions-item>
                <a-descriptions-item label="缴费金额">
                  <span class="danger">¥{{ billGenerationResult.amount }}</span>
                </a-descriptions-item>
              </a-descriptions>
            </a-card>
          </div>
        </a-form>
      </div>

      <!-- 批量生成 -->
      <div v-show="activeTab === 'batch'">
        <div class="section-head">
          <div class="section-title">批量生成多个月账单</div>
          <a-tag color="purple">单户 · 多月</a-tag>
        </div>

        <a-form layout="vertical" class="form-wrap">
          <a-row :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item label="楼号 *">
                <a-input v-model="batch.building" allowClear placeholder="请输入楼号" @blur="loadBatchFloorArea"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item label="房号 *">
                <a-input v-model="batch.room" allowClear placeholder="请输入房号" @blur="loadBatchFloorArea"/>
              </a-form-item>
            </a-col>
            <!-- 第1期起始日期 + 账单期数 -->
            <a-col :xs="24" :md="12">
              <a-form-item label="第1期起始日期 *">
                <a-date-picker
                  v-model="batch.startDate"
                  style="width:100%"
                  format="YYYY-MM-DD"
                  placeholder="请选择第1期起始日期"
                  @change="onBatchStartDateChange"
                />
              </a-form-item>
            </a-col>

            <a-col :xs="24" :md="12">
              <a-form-item label="账单期数 *">
                <a-input-number
                  v-model="batch.periodCount"
                  :min="1"
                  :max="120"
                  :step="1"
                  style="width:100%"
                  placeholder="例如：5"
                  @change="onBatchStartDateChange"
                />
              </a-form-item>
            </a-col>

            <a-col :xs="24" :md="12">
              <a-form-item label="费用类型">
                <a-select v-model="batch.feeType">
                  <a-select-option v-for="t in feeTypes" :key="t" :value="t">{{ t }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :xs="24" :md="8">
              <a-form-item label="每平米费用（元）">
                <a-input-number
                  v-model="batch.amountPerSqm"
                  :min="0"
                  :step="0.01"
                  :precision="2"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>

            <a-col :xs="24" :md="12">
              <a-form-item label="房屋面积（㎡）（自动）">
                <a-input :value="batch.floorArea != null ? String(batch.floorArea) : ''" disabled placeholder="输入楼号房号后自动获取" />
              </a-form-item>
            </a-col>

            <a-col :xs="24" :md="12">
              <a-form-item label="每期费用金额（自动）">
                <a-input :value="batch.floorArea != null ? String(calcBatchAmount()) : ''" disabled />
              </a-form-item>
            </a-col>

            <!--（可选但强烈建议）自动预览前几期 -->
            <a-col :xs="24">
              <a-form-item label="预览（自动生成）">
                <a-table
                  size="small"
                  :data-source="batchPreviewPeriods"
                  :columns="batchPreviewColumns"
                  :pagination="false"
                  rowKey="period_number"
                  :scroll="{ x: 900 }"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <div class="form-actions">
            <a-button type="primary" :loading="loading.batch" @click="handleBatchGenerate">
              批量生成账单（按期数）
            </a-button>
            <a-button :disabled="loading.batch" @click="resetBatch">清空</a-button>
          </div>

          <!-- 批量结果 -->
          <div v-if="batchGenerationResult" class="result-box">
            <a-alert
              :message="`批量生成完成：成功 ${batchGenerationResult.successCount} 个，失败 ${batchGenerationResult.failCount} 个`"
              :type="batchGenerationResult.failCount > 0 ? 'warning' : 'success'"
              show-icon
              style="margin-bottom: 12px"
            />

            <a-collapse :bordered="false" class="result-collapse">
              <a-collapse-panel
                v-if="batchGenerationResult.successCount > 0"
                key="ok"
                :header="`成功明细（${batchGenerationResult.successCount}）`"
              >
                <a-table
                  :rowKey="(_, i) => i"
                  :dataSource="batchGenerationResult.successBills"
                  :pagination="{ pageSize: 8 }"
                  :columns="successColumns"
                  size="small"
                />
              </a-collapse-panel>

              <a-collapse-panel
                v-if="batchGenerationResult.failCount > 0"
                key="fail"
                :header="`失败明细（${batchGenerationResult.failCount}）`"
              >
                <div class="fail-list">
                  <div
                    v-for="(item, idx) in batchGenerationResult.failMessages"
                    :key="idx"
                    class="fail-item"
                  >
                    <span class="danger-text">{{ item }}</span>
                  </div>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-form>
      </div>
      <!-- ✅ 新增：收款账号管理 -->
      <div v-show="activeTab === 'pay_accounts'">
        <div class="section-head">
          <div class="section-title">收款账号信息管理</div>
          <a-tag color="cyan">同一项目可维护多条收款账号信息</a-tag>
          <a-button style="margin-left:auto" icon="reload" :loading="payAccounts.loading" @click="loadPayAccounts">
            刷新
          </a-button>
        </div>

        <a-alert
          type="info"
          show-icon
          class="mb-3"
          message="支持行内编辑：直接修改后点击“保存”；最后一行可“新增账号信息”。"
        />

        <a-table
          :columns="payAccountColumns"
          :data-source="payAccounts.rows"
          :loading="payAccounts.loading"
          row-key="__rid"
          bordered
          :pagination="false"
        >
          <!-- 序号 -->
          <template slot="idx" slot-scope="text, record, index">
            {{ index + 1 }}
          </template>

          <!-- 银行账户名称：行内输入 -->
          <template slot="bank_account_name" slot-scope="text, record">
            <a-input v-model="record.bank_account_name" placeholder="银行账户名称" />
          </template>

          <!-- 银行账号：行内输入 -->
          <template slot="bank_account_no" slot-scope="text, record">
            <a-input v-model="record.bank_account_no" placeholder="银行账号" />
          </template>

          <!-- 开户行名称：行内输入 -->
          <template slot="bank_name" slot-scope="text, record">
            <a-input v-model="record.bank_name" placeholder="开户行名称" />
          </template>

          <!-- 启用状态：开关 -->
          <template slot="active" slot-scope="text, record">
            <a-switch v-model="record.active" />
          </template>

          <!-- 操作 -->
          <template slot="actions" slot-scope="text, record, index">
            <!-- 新增行：显示“新增/保存” -->
            <template v-if="record.__isNew">
              <a-button type="primary" size="small" :loading="!!record.__saving" @click="savePayAccount(record)">
                保存
              </a-button>
              <a-button size="small" style="margin-left:8px" :disabled="!!record.__saving" @click="removeNewRow(index)">
                取消
              </a-button>
            </template>

            <!-- 已存在：显示“保存/删除” -->
            <template v-else>
              <a-button size="small" type="primary" :loading="!!record.__saving" @click="savePayAccount(record)">
                保存
              </a-button>

              <a-divider type="vertical" />

              <a-popconfirm
                title="确认删除该收款账号？"
                ok-text="确认"
                cancel-text="取消"
                @confirm="deletePayAccount(record)"
              >
                <a-button size="small" type="danger" :loading="!!record.__deleting">
                  删除
                </a-button>
              </a-popconfirm>
            </template>
          </template>
        </a-table>

        <!-- ✅ 最后一条：新增按钮 -->
        <div class="add-row-wrap">
          <a-button icon="plus" type="dashed" block @click="addNewPayAccountRow">
            新增账号信息
          </a-button>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: "BillGeneration",
  data() {
    return {
      activeTab: "single",

      years: [2024, 2025, 2026],
      feeTypes: ["物业费", "房租"],

      single: {
        building: "",
        room: "",
        startDate: null,       // ✅ moment/dayjs
        feeType: "物业费",
        amountPerSqm: 1,
        // ✅ 从 accounts 拉回来的面积
        floorArea: null,       // number
        floorAreaLoading: false,
      },
      batch: {
        building: "",
        room: "",
        startDate: null,     // ✅ 第1期起始日（moment/dayjs）
        periodCount: 1,      // ✅ 期数 N
        feeType: "物业费",    // ✅ 物业费 / 房租
        amountPerSqm: 1,     // ✅ 每平米费用
        floorArea: null,     // ✅ 面积（从 ElectricityAccount 拿）
        floorAreaLoading: false,
      },

      ownerSingle: null,
      ownerBatch: null,

      loading: { single: false, batch: false },

      billGenerationResult: null,
      batchGenerationResult: null,
      errorMessage: "",
      payAccounts: {
        loading: false,
        rows: []
      },
      payAccountColumns: [
        { title: '序号', key: 'idx', width: 70, scopedSlots: { customRender: 'idx' } },
        { title: '银行账户名称', dataIndex: 'bank_account_name', key: 'bank_account_name', scopedSlots: { customRender: 'bank_account_name' } },
        { title: '银行账号', dataIndex: 'bank_account_no', key: 'bank_account_no', scopedSlots: { customRender: 'bank_account_no' } },
        { title: '开户行名称', dataIndex: 'bank_name', key: 'bank_name', scopedSlots: { customRender: 'bank_name' } },
        { title: '启用状态', dataIndex: 'active', key: 'active', width: 110, scopedSlots: { customRender: 'active' } },
        { title: '操作', key: 'actions', width: 220, scopedSlots: { customRender: 'actions' } }
      ],

    };
  },
  computed: {
    singleResultVisible() {
      return !!this.billGenerationResult || !!this.errorMessage;
    },
    successColumns() {
      return [
        { title: "楼号", dataIndex: "building", key: "building", width: 90 },
        { title: "房号", dataIndex: "room", key: "room", width: 90 },
        { title: "月份", dataIndex: "month", key: "month", width: 90, customRender: (t) => `${t}月` },
        { title: "费用类型", dataIndex: "feeType", key: "feeType", width: 120 },
        { title: "金额", dataIndex: "amount", key: "amount", width: 120, customRender: (t) => `¥${t}` },
      ];
    },
    // ✅ 自动计算：end_date = start_date 下个月同一日 - 1 天
    singleEndDate() {
      const s = this.single.startDate
      if (!s) return null
      // moment/dayjs 都支持 add/subtract
      if (typeof s.clone === "function") return s.clone().add(1, "month").subtract(1, "day")
      // 兜底：如果不是 moment/dayjs，就返回 null
      return null
    },

    singleStartDateText() {
      const s = this.single.startDate
      if (!s) return ""
      return (typeof s.format === "function") ? s.format("YYYY-MM-DD") : ""
    },

    singleEndDateText() {
      const e = this.singleEndDate
      if (!e) return ""
      return (typeof e.format === "function") ? e.format("YYYY-MM-DD") : ""
    },
    // 面积展示文本
    floorAreaText() {
      const a = this.single.floorArea
      if (a == null || Number.isNaN(Number(a))) return ""
      return String(a)
    },

    // 计算出的金额
    calculatedAmount() {
      const area = Number(this.single.floorArea || 0)
      const price = Number(this.single.amountPerSqm || 0)
      const v = area * price
      return Number.isFinite(v) ? v : 0
    },

    calculatedAmountText() {
      const v = this.calculatedAmount
      if (!v) return "0.00"
      return v.toFixed(2)
    },
    batchPreviewColumns() {
      return [
        { title: "期数", dataIndex: "period_number", width: 80 },
        { title: "起始日期", dataIndex: "start_date", width: 140 },
        { title: "结束日期", dataIndex: "end_date", width: 140 },
        { title: "应收日期", dataIndex: "due_date", width: 140 },
        { title: "应收合计", dataIndex: "receivable_amount", width: 120 },
        { title: "房租", dataIndex: "rent_amount", width: 120 },
        { title: "物业费", dataIndex: "property_fee_amount", width: 120 },
      ]
    },

    // ✅ 预览：最多展示前 12 期，避免表太长
    batchPreviewPeriods() {
      const periods = this.buildBatchPeriods({ previewLimit: 12 })
      return periods
    },
  },
  methods: {
    goToFeeQuery() {
      this.$router.push({ path: "/owner_mg/fee_query" }); // 按你项目实际路径改
    },

    getCompTeam() {
      const comp_id = Number(localStorage.getItem("comp_id") || localStorage.getItem("camp_id") || 1);
      const team_id = Number(localStorage.getItem("team_id") || 1);
      return { comp_id, team_id };
    },

    async fetchOwnerInfo(building, room) {
      // ✅ 改用本地 API
      const { team_id } = this.getCompTeam();
      const res = await request({
        url: "/electricity/accounts/",
        method: "get",
        params: { building_no: building, unit_no: room, team_id },
      });
      const data = res && res.data ? res.data : res;
      const list = Array.isArray(data) ? data : (data?.results || []);
      if (!list.length) throw new Error("未找到该业主");
      return list[0];
    },

    async createBill(payload) {
      // ✅ 改用本地 API
      // 需要先根据 building+room 获取业主 ID
      const { team_id } = this.getCompTeam();
      const ownerRes = await request({
        url: "/electricity/accounts/",
        method: "get",
        params: { building_no: payload.building, unit_no: payload.room, team_id },
      });
      const ownerData = ownerRes && ownerRes.data ? ownerRes.data : ownerRes;
      const ownerList = Array.isArray(ownerData) ? ownerData : (ownerData?.results || []);
      if (!ownerList.length) {
        return { success: false, error: "未找到该业主" };
      }
      const accountId = ownerList[0].id;

      // 创建账单
      const billPayload = {
        account: accountId,
        period_number: payload.period_number,
        payment_type: payload.payment_type,
        start_date: payload.start_date,
        end_date: payload.end_date,
        due_date: payload.due_date,
        receivable_amount: payload.receivable_amount,
        received_amount: payload.received_amount || 0,
        rent_amount: payload.rent_amount,
        property_fee_amount: payload.property_fee_amount,
      };

      try {
        const res = await request({
          url: "/electricity/property-bills/",
          method: "post",
          data: billPayload,
        });
        const result = res && res.data ? res.data : res;
        if (result && result.id) {
          return { success: true, bill: result };
        }
        return { success: false, error: result?.detail || "创建账单失败" };
      } catch (e) {
        return { success: false, error: e.response?.data?.detail || "创建账单失败" };
      }
    },


    resetSingle() {
      this.single = {
        building: "",
        room: "",
        startDate: null,
        feeType: "物业费",
        amountPerSqm: 1,
        floorArea: null,
        floorAreaLoading: false,
      }
      this.ownerSingle = null
      this.billGenerationResult = null
      this.errorMessage = ""
    },


    resetBatch() {
      this.batch = {
        building: "",
        room: "",
        startDate: null,
        periodCount: 1,
        feeType: "物业费",
        amountPerSqm: 1,
        floorArea: null,
        floorAreaLoading: false,
      }
      this.ownerBatch = null
      this.batchGenerationResult = null
    },

    validateSingle() {
      const s = this.single
      if (!s.building || !s.room) {
        this.$message.error("请填写楼号、房号")
        return false
      }
      if (!s.startDate) {
        this.$message.error("请选择账单起始日期")
        return false
      }
      if (s.amountPerSqm == null || Number(s.amountPerSqm) < 0) {
        this.$message.error("请填写正确的每平米费用")
        return false
      }
      if (this.single.floorArea == null) {
        this.$message.error("尚未获取到房屋面积，请检查楼号/房号是否存在")
        return false
      }
      return true
    },
    validateBatch() {
      const b = this.batch
      if (!b.building || !b.room) {
        this.$message.error("请填写楼号、房号")
        return false
      }
      if (!b.startDate) {
        this.$message.error("请选择第1期起始日期")
        return false
      }
      const n = Number(b.periodCount)
      if (!Number.isInteger(n) || n <= 0) {
        this.$message.error("请输入正确的账单期数（正整数）")
        return false
      }
      if (this.batch.floorArea == null) {
        this.$message.error("尚未获取到房屋面积，请检查楼号/房号是否存在")
        return false
      }
      return true
    },

    onSingleStartDateChange() {
      // ✅ 改日期后，把上次生成结果/错误清掉，避免误解
      this.billGenerationResult = null
      this.errorMessage = ""
    },
    // 把 moment / dayjs 统一转 YYYY-MM-DD
    toYMD(d) {
      if (!d) return ""
      if (typeof d === "string") return d.slice(0, 10)
      if (typeof d.format === "function") return d.format("YYYY-MM-DD") // moment/dayjs
      return ""
    },

    async tryFetchFloorArea() {
      const building_no = String(this.single.building || "").trim()
      const unit_no = String(this.single.room || "").trim()
      if (!building_no || !unit_no) return

      // 避免重复刷接口（可选）
      await this.fetchFloorArea(building_no, unit_no)
    },

    async fetchFloorArea(building_no, unit_no) {
      const { comp_id, team_id } = this.getCompTeam()

      this.single.floorAreaLoading = true
      try {
        // ✅ 这里按你后端的 accounts 路由：/electricity/accounts/
        // 如果你的前端 request 已经有 baseURL('/api')，那就用相对路径
        const res = await request({
          url: "/electricity/accounts/",
          method: "get",
          params: {
            building_no,
            unit_no,
            team_id,   // 如果你后端需要 team_id 过滤
            comp_id,   // 如果你后端也需要
            page_size: 1,
          },
        })

        const data = res && res.data ? res.data : res
        const list = Array.isArray(data) ? data : (Array.isArray(data?.results) ? data.results : [])

        if (!list.length) {
          this.single.floorArea = null
          this.$message.warning("无此业主信息）")
          return
        }

        const floor_area = list[0].floor_area
        this.single.floorArea = floor_area != null ? Number(floor_area) : null
      } catch (e) {
        console.error(e)
        this.single.floorArea = null
        this.$message.error("获取面积数据失败，请检查 accounts 接口或参数")
      } finally {
        this.single.floorAreaLoading = false
      }
    },

    async loadBatchFloorArea() {
      const b = String(this.batch.building || "").trim()
      const r = String(this.batch.room || "").trim()
      if (!b || !r) return

      const { comp_id, team_id } = this.getCompTeam()
      this.batch.floorAreaLoading = true
      try {
        // 按你后端 ElectricityAccountViewSet 字段：building_no / unit_no
        const res = await request({
          url: "/electricity/accounts/",
          method: "get",
          params: { building_no: b, unit_no: r, comp_id, team_id },
        })
        const data = res?.data ?? res
        const item = Array.isArray(data?.results) ? data.results[0] : (Array.isArray(data) ? data[0] : data)
        const area = item?.floor_area
        this.batch.floorArea = area != null ? Number(area) : null
      } catch (e) {
        console.error(e)
        this.batch.floorArea = null
      } finally {
        this.batch.floorAreaLoading = false
      }
    },


    // ✅ 计算：end = start + 1 month - 1 day
    calcEndDate(startMoment) {
      if (!startMoment) return null
      return startMoment.clone().add(1, "month").subtract(1, "day")
    },

    // ✅ 统一格式 YYYY-MM-DD
    fmt(d) {
      return d && typeof d.format === "function" ? d.format("YYYY-MM-DD") : ""
    },

    // ✅ 计算本次批量的“每期金额”
    calcBatchAmount() {
      const area = Number(this.batch.floorArea || 0)
      const feePerSqm = Number(this.batch.amountPerSqm || 0)
      const amount = +(area * feePerSqm).toFixed(2)
      return amount
    },

    // ✅ 生成 N 期 rental_periods（可用于预览/提交）
    buildBatchPeriods({ previewLimit } = {}) {
      const b = this.batch
      if (!b.startDate || !b.periodCount) return []

      const count = Math.max(1, Number(b.periodCount || 1))
      const limit = previewLimit ? Math.min(count, previewLimit) : count

      const amount = this.calcBatchAmount()

      const periods = []
      let start = b.startDate.clone()

      for (let i = 1; i <= limit; i++) {
        const end = this.calcEndDate(start)
        const start_date = this.fmt(start)
        const end_date = this.fmt(end)
        const due_date = start_date

        const rent_amount = b.feeType === "房租" ? amount : 0
        const property_fee_amount = b.feeType === "物业费" ? amount : 0
        const receivable_amount = +(rent_amount + property_fee_amount).toFixed(2)

        periods.push({
          period_number: i,
          payment_type: b.feeType,          // 你之前用 feeType，第三方字段叫 payment_type
          start_date,
          end_date,
          due_date,
          receivable_amount,
          received_amount: 0,
          rent_amount,
          property_fee_amount,
        })

        // 下一期 start = 本期 end + 1 day
        start = end.clone().add(1, "day")
      }

      return periods
    },

    onBatchStartDateChange() {
      // ✅ 改参数就清掉结果
      this.batchGenerationResult = null
      this.errorMessage = ""
    },


    async handleSingleGenerate() {
      if (!this.validateSingle()) return;

      this.errorMessage = "";
      this.billGenerationResult = null;

      try {
        this.loading.single = true;

        const building = String(this.single.building).trim();
        const room = String(this.single.room).trim();

        // team_id
        const { team_id } = this.getCompTeam();
        if (!team_id) {
          this.errorMessage = "无法获取 team_id";
          return;
        }

        //（可选）拉业主信息，用于展示“业主姓名”
        let ownerName = "";
        try {
          const owner = await this.fetchOwnerInfo(building, room);
          ownerName = owner?.owner_name || owner?.ownerName || "";
        } catch (e) {
          // 不影响生成账单
        }

        // 面积
        if (this.single.floorArea == null) await this.fetchFloorArea(building, room);
        const area = Number(this.single.floorArea || 0);

        // 日期
        const start_date = this.singleStartDateText;
        const end_date = this.singleEndDateText;
        const due_date = start_date;

        // 金额
        const amount = Number((area * Number(this.single.amountPerSqm || 0)).toFixed(2));
        const isProperty = this.single.feeType === "物业费";
        const rent_amount = isProperty ? 0 : amount;
        const property_fee_amount = isProperty ? amount : 0;
        const receivable_amount = Number((rent_amount + property_fee_amount).toFixed(2));

        // ✅ period_number = 账单月份（从 start_date 提取）
        // 与批量生成逻辑一致：period_number 代表账单所属的月份
        let periodNumber = 1;
        if (start_date) {
          const match = start_date.match(/^\d{4}-(\d{1,2})-\d{1,2}$/);
          if (match) {
            periodNumber = parseInt(match[1], 10);
          }
        }

        const payload = {
          building,
          room,
          team_id: Number(team_id),

          period_number: periodNumber,
          payment_type: this.single.feeType,

          start_date,
          end_date,
          due_date,

          receivable_amount,
          received_amount: 0,

          rent_amount,
          property_fee_amount,

          pay_status: 0,
        };

        const j = await this.createBill(payload);

        if (!j || !j.success) {
          this.errorMessage = (j && j.error) || "生成失败";
          return;
        }

        // 前端展示
        this.billGenerationResult = {
          feePeriod: `${start_date} ~ ${end_date}`,
          amount: receivable_amount.toFixed(2),
          ownerName: ownerName || "—",
          room,
          building,
          feeType: this.single.feeType,
        };

        this.$message.success("单个账单生成成功");
      } catch (err) {
        console.error(err);
        this.errorMessage = err?.message || "网络错误";
      } finally {
        this.loading.single = false;
      }
    },



    async handleBatchGenerate() {
      if (!this.validateBatch()) return;

      try {
        this.loading.batch = true;
        this.batchGenerationResult = null;
        this.errorMessage = "";

        const building = String(this.batch.building).trim();
        const room = String(this.batch.room).trim();

        const { team_id } = this.getCompTeam();
        if (!team_id) throw new Error("无法获取 team_id");

        //（可选）拉业主名用于展示
        let ownerName = "";
        try {
          const owner = await this.fetchOwnerInfo(building, room);
          ownerName = owner?.owner_name || owner?.ownerName || "";
        } catch (e) {}

        // 生成 N 期（你原来的 buildBatchPeriods 已经包含 period_number/payment_type/start/end/due/金额拆分）
        const periods = this.buildBatchPeriods(); // 全量 N

        let successCount = 0;
        let failCount = 0;
        const successBills = [];
        const failMessages = [];

        // ✅ 建议串行调用，避免压接口；如果后续要并发池我也可以给你
        for (let i = 0; i < periods.length; i++) {
          const p = periods[i];

          const payload = {
            building,
            room,
            team_id: Number(team_id),

            period_number: Number(p.period_number || (i + 1)),
            payment_type: String(p.payment_type || this.batch.feeType || "").trim(),

            start_date: p.start_date,
            end_date: p.end_date,
            due_date: p.due_date,

            receivable_amount: Number(p.receivable_amount || 0),
            received_amount: Number(p.received_amount || 0),

            rent_amount: Number(p.rent_amount || 0),
            property_fee_amount: Number(p.property_fee_amount || 0),

            pay_status: 0,
          };

          try {
            const j = await this.createBill(payload);
            if (j && j.success) {
              successCount++;
              successBills.push({
                building,
                room,
                month: payload.period_number, // 你原来 successColumns 用 month，这里继续复用
                feeType: payload.payment_type,
                amount: payload.receivable_amount,
                start_date: payload.start_date,
                end_date: payload.end_date,
                ownerName,
              });
            } else {
              failCount++;
              failMessages.push(
                `第${payload.period_number}期（${payload.start_date}~${payload.end_date}）生成失败：${(j && j.error) || "未知错误"}`
              );
            }
          } catch (e) {
            console.error(e);
            failCount++;
            failMessages.push(
              `第${payload.period_number}期（${payload.start_date}~${payload.end_date}）生成失败：${e?.message || "网络错误"}`
            );
          }
        }

        this.batchGenerationResult = {
          successCount,
          failCount,
          failMessages,
          successBills,
        };

        if (failCount > 0) {
          this.$message.warning(`批量生成完成：成功 ${successCount}，失败 ${failCount}`);
        } else {
          this.$message.success(`批量生成完成：成功 ${successCount}`);
        }
      } catch (err) {
        console.error(err);
        this.$message.error(err?.message || "网络错误");
      } finally {
        this.loading.batch = false;
      }
    },


    openPayAccountsTab () {
      this.activeTab = 'pay_accounts'
      this.loadPayAccounts()
    },

    async loadPayAccounts () {
      this.payAccounts.loading = true
      try {
        const res = await request({
          url: '/manage_data/pay_accounts/',
          method: 'get',
          params: {} // 这里也可加 active=true 用于下拉，但管理页建议拉全量
        })

        const list =
          Array.isArray(res) ? res :
          Array.isArray(res?.data) ? res.data :
          Array.isArray(res?.results) ? res.results : []

        // 加上前端辅助字段
        this.payAccounts.rows = list.map(x => ({
          __rid: x.id,        // rowKey
          ...x,
          __isNew: false,
          __saving: false,
          __deleting: false
        }))
      } catch (e) {
        console.error(e)
        this.$message.error(e?.response?.data?.detail || e?.message || '加载收款账号失败')
        this.payAccounts.rows = []
      } finally {
        this.payAccounts.loading = false
      }
    },

    addNewPayAccountRow () {
      // 防止重复添加多个空行（你也可以允许多个）
      const hasNew = this.payAccounts.rows.some(r => r.__isNew)
      if (hasNew) return this.$message.warning('请先保存当前新增行')

      this.payAccounts.rows.push({
        __rid: `new_${Date.now()}`,
        __isNew: true,
        __saving: false,
        __deleting: false,

        bank_account_name: '',
        bank_account_no: '',
        bank_name: '',
        active: true
      })
    },

    removeNewRow (index) {
      this.payAccounts.rows.splice(index, 1)
    },

    validatePayAccountRow (r) {
      if (!r.bank_account_name) return '请输入银行账户名称'
      if (!r.bank_account_no) return '请输入银行账号'
      if (!r.bank_name) return '请输入开户行名称'
      return null
    },

    async savePayAccount (record) {
      const msg = this.validatePayAccountRow(record)
      if (msg) return this.$message.warning(msg)

      record.__saving = true
      try {
        // ✅ 新增
        if (record.__isNew) {
          const res = await request({
            url: '/manage_data/pay_accounts/',
            method: 'post',
            data: {
              bank_account_name: record.bank_account_name,
              bank_account_no: record.bank_account_no,
              bank_name: record.bank_name,
              active: !!record.active
            }
          })
          const obj = res?.data || res

          // 用后端返回覆盖并转成“已存在行”
          record.id = obj.id
          record.__rid = obj.id
          record.__isNew = false
          this.$message.success('新增成功')
          return
        }

        // ✅ 更新
        await request({
          url: `/manage_data/pay_accounts/${record.id}/`,
          method: 'patch',
          data: {
            bank_account_name: record.bank_account_name,
            bank_account_no: record.bank_account_no,
            bank_name: record.bank_name,
            active: !!record.active
          }
        })
        this.$message.success('保存成功')
      } catch (e) {
        console.error(e)
        const detail = e?.response?.data?.detail
        // 唯一约束冲突时，后端可能返回字段错误
        const fieldErr =
          e?.response?.data?.bank_account_no?.[0] ||
          e?.response?.data?.bank_account_name?.[0] ||
          e?.response?.data?.bank_name?.[0]
        this.$message.error(detail || fieldErr || e?.message || '保存失败')
      } finally {
        record.__saving = false
      }
    },

    async deletePayAccount (record) {
      if (!record?.id) return
      record.__deleting = true
      try {
        await request({
          url: `/manage_data/pay_accounts/${record.id}/`,
          method: 'delete'
        })
        this.payAccounts.rows = this.payAccounts.rows.filter(r => r.__rid !== record.__rid)
        this.$message.success('已删除')
      } catch (e) {
        console.error(e)
        this.$message.error(e?.response?.data?.detail || e?.message || '删除失败')
      } finally {
        record.__deleting = false
      }
    },

  },
};
</script>

<style scoped>
.bill-generation-page { padding: 16px; }

.toolbar-card,
.content-card {
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.06);
}
.toolbar-card { margin-bottom: 16px; }

.toolbar-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.page-title { font-size: 18px; font-weight: 900; line-height: 1.2; }
.page-sub { margin-top: 6px; }
.toolbar-right { display: flex; gap: 8px; flex-wrap: wrap; }

.switch-row { margin-bottom: 16px; }
.switch-card {
  cursor: pointer;
  border-radius: 14px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(0,0,0,0.06);
}
.switch-card:hover { transform: translateY(-2px); box-shadow: 0 8px 18px rgba(0,0,0,0.10); }
.switch-card.active {
  box-shadow: 0 10px 22px rgba(24,144,255,0.18);
  outline: 2px solid rgba(24,144,255,0.35);
}
.switch-title { font-size: 16px; font-weight: 900; }
.switch-sub { margin-top: 6px; color: rgba(0,0,0,0.45); }

.section-head { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
.section-title { font-size: 16px; font-weight: 900; }

.form-wrap { max-width: 900px; }
.form-actions { display: flex; gap: 8px; margin-top: 6px; }

.result-box { margin-top: 16px; }
.result-card {
  border-radius: 14px;
  border: 1px solid rgba(0,0,0,0.06);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}
.result-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.result-title { font-size: 16px; font-weight: 900; }

.fail-list { display: flex; flex-direction: column; gap: 6px; }
.fail-item {
  padding: 8px 10px;
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 12px;
  background: #fafafa;
}
.danger { color: #d4380d; font-weight: 900; }
.danger-text { color: #d4380d; font-weight: 700; }

.muted { color: rgba(0,0,0,0.45); }
.mb-3 { margin-bottom: 12px; }

.add-row-wrap {
  margin-top: 12px;
}

</style>
